import styled from 'styled-components'

const LoginAppLogo = styled.img`
  margin-bottom: 16px;
`

export default LoginAppLogo



// WEBPACK FOOTER //
// ./src/components/templates/login/LoginAppLogo.js